import { Outlet } from "react-router-dom";
import Header from "@/components/navigation/Header";

/**
 * Dashboard layout with header navigation.
 */
export default function DashboardLayout() {
  return (
    <div className="flex flex-col h-screen bg-background overflow-hidden">
      <Header />
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}